import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from "@angular/core";
import { PendingLayer } from "../../model/i-pending-layers";

/**
 * Component for displaying and managing a single pending layer item in the add-user-data dialog.
 * Renders a compact, non-expandable row with status icon/spinner, editable name, summary and actions.
 */
@Component({
  selector: "app-add-layer-item",
  templateUrl: "./add-layer-item.component.html",
  styleUrls: ["./add-layer-item.component.scss"],
  standalone: false,
})
export class AddLayerItemComponent {
  /** The pending layer to display. Updated in place by parent. */
  @Input() layer!: PendingLayer;

  /** The index of the layer in the list. */
  @Input() index!: number;

  /** Emits the index of the layer to remove. */
  @Output() onRemove = new EventEmitter<number>();

  /**
   * True when the layer has valid status but contains invalid features,
   * in which case we show a warning icon and tooltip.
   */
  get isWarning(): boolean {
    return this.layer?.status === "valid" && (this.layer?.summary?.invalidFeatures || 0) > 0;
  }

  /**
   * Returns a list of unique error messages for display, removing duplicates and empty strings.
   * @returns {string[]} Array of unique error messages.
   */
  get uniqueErrorMessages(): string[] {
    if (!this.layer?.errorMessages?.length) return [];
    return Array.from(new Set(this.layer.errorMessages.map((m) => this.capitalizeFirst(m)))).filter((msg) => !!msg);
  }

  // /**
  //  * Returns true if the layer name is empty or only whitespace.
  //  */
  // get isLayerNameInvalid(): boolean {
  //   return !this.layer.layerName || !this.layer.layerName.trim();
  // }

  capitalizeFirst(text: string): string {
    if (!text) return "";
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  /**
   * Emits the removeLayer event for this layer.
   */
  removeLayer(): void {
    this.onRemove.emit(this.index);
  }
}
